export const IMAGE_FILE = 'image';
export const VIDEO_FILE = 'video';
export const AUDIO_FILE = 'audio';
export const SVG_FILE = 'svg';

export const SUPPORTED_TYPES = {
  [IMAGE_FILE]: [
    'image/jpeg',
    'image/png',
    '.jpg',
    '.jpeg',
    '.png',
    'image/gif',
    '.gif',
    'image/webp',
    '.webp',
  ].join(','),
  [AUDIO_FILE]: ['audio/mpeg', '.mp3'].join(','),
  [VIDEO_FILE]: [
    'video/avi',
    'video/mp4',
    'video/mov',
    'video/quicktime',
    'video/flv',
    'video/wmv',
    'video/x-ms-asf',
    'video/x-flv',
    'video/x-matroska',
    'video/x-ms-wmv',
    'video/x-msvideo',
    '.avi',
    '.mp4',
    '.mkv',
    '.mov',
    '.flv',
    '.wmv',
  ].join(','),
  [SVG_FILE]: ['image/svg+xml', '.svg'].join(','),
};

export const SUPPORTED_SIZES = {
  [IMAGE_FILE]: 10,
  [VIDEO_FILE]: 100,
  [AUDIO_FILE]: 100,
  [SVG_FILE]: 10,
};

export const SUPPORTED_DURATIONS = {
  [VIDEO_FILE]: 120,
  [AUDIO_FILE]: 120,
};

export const FILE_TYPE_MAP = {
  '.flv': 'video/x-flv',
  '.mp4': 'video/mp4',
  '.mov': 'video/quicktime',
  '.wmv': 'video/x-ms-asf', // audio/mp3
  '.mkv': 'video/x-matroska',
  '.avi': 'video/x-msvideo',
  '.mp3': 'audio/mpeg',
};

export const SIZE = {
  FULL: 'full',
  MIDDLE: 'middle',
  SMALL: 'small',
};
